/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import { Container, Card, FormControl, InputLabel, Checkbox, FormHelperText } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Box, Button } from '@material-ui/core';
import SearchNotFound from '../../../SearchNotFound';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableFooter from '@material-ui/core/TableFooter';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles';
import services from '../Service';
import { makeStyles } from '@material-ui/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';


var screenCode = "FDCVEHICLEUTILIZATIONREPORT"

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;
    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));

export default function FDCVehicleUtilizationView(props) {

    const navigate = useNavigate();
    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const classes = useStyles();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'FDC Vehicle Utilization Report'
    });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [datevalue, setDateValue] = useState(new Date());
    const [toDatevalue, setToDateValue] = useState(new Date());
    const [vehicleUtilizationData, setVehicleUtilizationData] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: '',
        date: null,
        toDate: null,
        isActive: true
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const FDCVehicleUtilizationReportSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.array().required('Please select at least one Fresh collection center').min(1, 'Please select at least one Fresh collection center'),
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupName: '',
        factoryName: '',
        date: '',
        toDate: '',
    });

    const truncateSheetName = (name) => {
        return name.length > 31 ? name.substring(0, 31) : name;
    }

    const [total, setTotalValues] = useState({
        totalVolume: 0,
        totalNumOfLorry: 0,
    });
    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            date: formData.date,
            toDate: formData.toDate,
            isActive: formData.isActive
        },
        validationSchema: FDCVehicleUtilizationReportSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm(values));
        },
    });
    async function SubmitForm(values) {
        let model = {
            groupID: parseInt(values.groupID),
            operationEntityID: selectedOptions.map(x => x).join(',').toString(),
            fromDate: datevalue == null ? null : moment(datevalue).format('YYYY-MM-DD'),
            toDate: toDatevalue == null ? null : moment(toDatevalue).format('YYYY-MM-DD'),
        }
        var res = await services.GetFDCVehicleUtilizationReportDetails(model)
        setVehicleUtilizationData(res);
        getSelectedDropdownValuesForReport(model);
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    useEffect(() => {
        getPermissions()
    }, []);

    useEffect(() => {

    }, []);

    function calculateTotal() {
        const totalVolume = vehicleUtilizationData.reduce((accumulator, current) => {
            const progressFraction = current.volume;
            return accumulator + progressFraction;
        }, 0);
        const uniqueVehicles = new Set();

        vehicleUtilizationData.forEach(item => {
            const dateStr = item.date;
            const groupKey = `${dateStr}|${item.vehicleCode}`;
            uniqueVehicles.add(groupKey);
        });

        const totalNumOfLorry = uniqueVehicles.size;
        setTotalValues({
            ...total,
            totalVolume: totalVolume,
            totalNumOfLorry: totalNumOfLorry,
        });
    }

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFDCVEHICLEUTILIZATIONREPORT');
        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });
        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group)
        })
        trackPromise(GetAllGroups());
    }

    async function clearAll() {
        setDateValue(new Date());
        setToDateValue(new Date());
        setVehicleUtilizationData([]);
        if (!permissionList.isFactoryFilterEnabled) {
            setSelectedOptions([]);
        } else {
            setSelectedOptions([]);
        }
    }

    useEffect(() => {
        trackPromise(GetAllGroups());
    }, []);

    useEffect(() => {
        setPage(0);
        if (vehicleUtilizationData.length != 0) {
            calculateTotal()
        }
    }, [vehicleUtilizationData]);

    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
        setDateValue(new Date());
        setToDateValue(new Date());
        setVehicleUtilizationData([]);
        setSelectedOptions([]);
    }, [formik.values.groupID]);

    useEffect(() => {
        setDateValue(new Date());
        setToDateValue(new Date());
        setVehicleUtilizationData([]);
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setVehicleUtilizationData([]);
        setToDateValue(new Date());
    }, [datevalue]);

    useEffect(() => {
        setVehicleUtilizationData([]);
    }, [toDatevalue]);

    useEffect(() => {
        setVehicleUtilizationData([]);
    }, [selectedOptions]);

    useEffect(() => {
        setValues({
            ...values,
            operationEntityID: selectedOptions
        })
    }, [selectedOptions]);

    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [factory]);

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetVCCFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setFactory(newOptionArray);
        }
    }

    async function createFile() {
        var file = await createDataForExcel(vehicleUtilizationData);
        var settings = {
            sheetName: 'FDC Vehicle Utilization Report',
            fileName: 'FDC Vehicle Utilization Report' + new Date(datevalue).toISOString().split('T')[0] + '-' + new Date(toDatevalue).toISOString().split('T')[0],
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: truncateSheetName('FDC Vehicle Utilization Report'),
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    const handleSelectChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedOptions(selectedOptions.length === factory.length ? [] : factory.map((option) => option.value));
        } else {
            setSelectedOptions(value);
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
    };

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            // Use a Map for grouping
            const groupedMap = new Map();
            array.forEach((item) => {
                const dateStr = moment(item.date).format('YYYY-MM-DD');
                const groupKey = `${dateStr}|${item.vehicleCode}`;
                if (!groupedMap.has(groupKey)) {
                    groupedMap.set(groupKey, {
                        date: dateStr,
                        numOfLorry: item.numOfLorry,
                        vehicleCode: item.vehicleCode,
                        size: item.size,
                        capacity: item.capacity,
                        rows: [],
                        totalVolume: 0
                    });
                }
                const group = groupedMap.get(groupKey);
                group.rows.push(item);
                group.totalVolume += item.volume;
            });

            const groupedData = Array.from(groupedMap.values());

            groupedData.forEach(group => {
                const utilization = group.capacity == 0
                    ? '-'
                    : parseFloat((group.totalVolume / group.capacity) * 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                group.rows.forEach((row, rowIdx) => {
                    res.push({
                        'Date': group.date,
                        'FCC': row.factoryName,
                        'Volume': row.volume == 0 ? '-' : parseFloat(row.volume).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'Number of Lorries': rowIdx === 0 ? group.numOfLorry : '',
                        'Vehicle Code': rowIdx === 0 ? group.vehicleCode : '',
                        'Lorry Size': rowIdx === 0 ? (group.size == 0 ? '-' : parseFloat(group.size).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) : '',
                        'Lorry Capacity': rowIdx === 0 ? (group.capacity == 0 ? '-' : parseFloat(group.capacity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) : '',
                        'Vehicle Utilization': rowIdx === 0 ? utilization : ''
                    });
                });
            });
        };
        var vrTwo = {
            'Date': 'Total',
            'Volume': isNaN(total.totalVolume) || total.totalVolume === 0 ? '-' : parseFloat(total.totalVolume).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            'Number of Lorries': isNaN(total.totalNumOfLorry) || total.totalNumOfLorry === 0 ? '-' : (total.totalNumOfLorry),
        }
        res.push(vrTwo);
        res.push({});
        res.push({});
        return res;
    }

    function getSelectedDropdownValuesForReport(data) {
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = factory.find(y => x === y.value).label
            facName.push(fildered)
        });
        let groups = group.find(x => x.groupID == formik.values.groupID)
        setSelectedSearchValues((prevState) => ({
            ...prevState,
            groupName: groups.groupName,
            factoryName: facName.length == 0 ? 'All Fresh Collection Centers' : facName.join(', '),
            date: new Date(datevalue).toLocaleDateString(),
            toDate: new Date(toDatevalue).toLocaleDateString()
        }));
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = factory.find((entity) => entity.value === selected[0]);
            return option ? option.label : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? option.label : null;
                } else {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? option.label : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    return (
        <>
            <LoadingComponent />
            <Page title="FDC Vehicle Utilization Report |  FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group </MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center "
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                            renderValue={(selected) => renderSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedOptions.length === factory.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {factory.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}
                                    </FormControl>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            size="small"
                                            label="From Date *"
                                            openTo="day"
                                            type="date"
                                            value={datevalue}
                                            onChange={(newValue) => {
                                                setDateValue(newValue);
                                            }}
                                            maxDate={new Date()}
                                            renderInput={(params) =>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                />}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            size="small"
                                            label="To Date *"
                                            openTo="day"
                                            type="date"
                                            value={toDatevalue}
                                            onChange={(newValue) => {
                                                setToDateValue(newValue);
                                            }}
                                            maxDate={new Date()}
                                            minDate={datevalue}
                                            renderInput={(params) =>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                />}
                                        />
                                    </LocalizationProvider>
                                    <div>
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                        > Clear</Button>
                                    </div>
                                    <div>
                                        <Button
                                            type="submit"
                                            color='secondary'
                                            variant="outlined"
                                        >Search</Button>
                                    </div>
                                </Stack>
                                <br />
                                <>
                                    {vehicleUtilizationData.length != 0 ? (
                                        <>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} >
                                                <Card style={{ justifycontent: 'center' }}>
                                                    <Paper className={classes.paper}>
                                                        <TableContainer className={classes.tableContainer} sx={{ maxWidth: 1800 }}>
                                                            <Table size="small" aria-label="simple table" sx={{ width: 1150 }}>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell sx={{ border: "1px solid black" }} align="left" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>&nbsp;&nbsp;&nbsp;Date</TableCell>
                                                                        <TableCell sx={{ border: "1px solid black" }} align="left" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>FCC</TableCell>
                                                                        <TableCell sx={{ border: "1px solid black" }} align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Volume&nbsp;</TableCell>
                                                                        <TableCell sx={{ border: "1px solid black" }} align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Number&nbsp;of&nbsp;Lorries</TableCell>
                                                                        <TableCell sx={{ border: "1px solid black" }} align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Vehicle&nbsp;Code</TableCell>
                                                                        <TableCell sx={{ border: "1px solid black" }} align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Lorry&nbsp;Size&nbsp;</TableCell>
                                                                        <TableCell sx={{ border: "1px solid black" }} align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Lorry&nbsp;Capacity&nbsp;</TableCell>
                                                                        <TableCell sx={{ border: "1px solid black" }} align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Vehicle&nbsp;Utilization&nbsp;%</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {(() => {
                                                                        const groupedMap = new Map();
                                                                        const paginatedData = rowsPerPage > 0
                                                                            ? vehicleUtilizationData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                            : vehicleUtilizationData;

                                                                        paginatedData.forEach((item) => {
                                                                            const dateStr = moment(item.date).format('YYYY-MM-DD');
                                                                            const groupKey = `${dateStr}|${item.vehicleCode}`;
                                                                            if (!groupedMap.has(groupKey)) {
                                                                                groupedMap.set(groupKey, {
                                                                                    date: dateStr,
                                                                                    numOfLorry: item.numOfLorry,
                                                                                    vehicleCode: item.vehicleCode,
                                                                                    size: item.size,
                                                                                    capacity: item.capacity,
                                                                                    rows: [],
                                                                                    totalVolume: 0
                                                                                });
                                                                            }
                                                                            const group = groupedMap.get(groupKey);
                                                                            group.rows.push(item);
                                                                            group.totalVolume += item.volume;
                                                                        });

                                                                        const groupedData = Array.from(groupedMap.values());

                                                                        return groupedData.map((group, groupIndex) => {
                                                                            const utilization = group.capacity == 0 ? '-' : parseFloat((group.capacity / group.totalVolume) * 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                                                            return (
                                                                                <React.Fragment key={groupIndex}>
                                                                                    {group.rows.map((row, rowIndex) => (
                                                                                        <TableRow key={rowIndex}>
                                                                                            <TableCell sx={{ border: "1px solid black", whiteSpace: "nowrap", verticalAlign: "middle" }} align="left">
                                                                                                {group.date}
                                                                                            </TableCell>
                                                                                            <TableCell sx={{ border: "1px solid black" }} align="left">
                                                                                                {row.factoryName}
                                                                                            </TableCell>
                                                                                            <TableCell sx={{ border: "1px solid black" }} align="right">
                                                                                                {row.volume == 0 ? '-' : parseFloat(row.volume).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                            </TableCell>
                                                                                            {rowIndex === 0 && (
                                                                                                <TableCell
                                                                                                    sx={{ border: "1px solid black", fontWeight: "bold", textAlign: 'center', verticalAlign: 'middle' }}
                                                                                                    align="center"
                                                                                                    rowSpan={group.rows.length}
                                                                                                >
                                                                                                    {group.numOfLorry}
                                                                                                </TableCell>
                                                                                            )}
                                                                                            {rowIndex === 0 && (
                                                                                                <TableCell
                                                                                                    sx={{ border: "1px solid black", fontWeight: "bold" }}
                                                                                                    align="center"
                                                                                                    rowSpan={group.rows.length}
                                                                                                    style={{ verticalAlign: 'middle', justifyContent: 'center' }}
                                                                                                >
                                                                                                    {group.vehicleCode}
                                                                                                </TableCell>
                                                                                            )}
                                                                                            {rowIndex === 0 && (
                                                                                                <TableCell
                                                                                                    sx={{ border: "1px solid black", fontWeight: "bold" }}
                                                                                                    align="center"
                                                                                                    rowSpan={group.rows.length}
                                                                                                    style={{ verticalAlign: 'middle', justifyContent: 'center' }}
                                                                                                >
                                                                                                    {group.size == 0 ? '-' : parseFloat(group.size).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                                </TableCell>
                                                                                            )}
                                                                                            {rowIndex === 0 && (
                                                                                                <TableCell
                                                                                                    sx={{ border: "1px solid black", fontWeight: "bold" }}
                                                                                                    align="center"
                                                                                                    rowSpan={group.rows.length}
                                                                                                    style={{ verticalAlign: 'middle', justifyContent: 'center' }}
                                                                                                >
                                                                                                    {group.capacity == 0 ? '-' : parseFloat(group.capacity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                                </TableCell>
                                                                                            )}
                                                                                            {rowIndex === 0 && (
                                                                                                <TableCell
                                                                                                    sx={{ border: "1px solid black", fontWeight: "bold" }}
                                                                                                    align="center"
                                                                                                    rowSpan={group.rows.length}
                                                                                                    style={{ verticalAlign: 'middle', justifyContent: 'center' }}
                                                                                                >
                                                                                                    {utilization}
                                                                                                </TableCell>
                                                                                            )}
                                                                                        </TableRow>
                                                                                    ))}
                                                                                </React.Fragment>
                                                                            );
                                                                        });
                                                                    })()}
                                                                    <TableRow>
                                                                        <TableCell style={{ border: "1px solid black", fontWeight: "bold" }} colSpan={2}>
                                                                            Total
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "1px solid black", fontWeight: "bold", textAlign: 'right', verticalAlign: 'middle' }}>
                                                                            {isNaN(total.totalVolume) || total.totalVolume === 0
                                                                                ? '-'
                                                                                : parseFloat(total.totalVolume).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "1px solid black", fontWeight: "bold", textAlign: 'center', verticalAlign: 'middle' }}>
                                                                            {isNaN(total.totalNumOfLorry) || total.totalNumOfLorry === 0
                                                                                ? '-'
                                                                                : total.totalNumOfLorry}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                </TableBody>
                                                                <TableFooter>
                                                                    <TableRow>
                                                                        <TablePagination
                                                                            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                                            colSpan={8}
                                                                            count={vehicleUtilizationData.length}
                                                                            rowsPerPage={rowsPerPage}
                                                                            page={page}
                                                                            SelectProps={{
                                                                                inputProps: {
                                                                                    'aria-label': 'rows per page',
                                                                                },
                                                                                native: true,
                                                                            }}
                                                                            onPageChange={handleChangePage}
                                                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                                                            ActionsComponent={TablePaginationActions}
                                                                        />
                                                                    </TableRow>
                                                                </TableFooter>
                                                            </Table>
                                                        </TableContainer>
                                                    </Paper>
                                                </Card>
                                            </Stack>
                                        </>
                                    )
                                        : <SearchNotFound searchQuery="FDC Vehicle Utilization Report" />}</>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    {vehicleUtilizationData.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Daily Purchasing Efficiency Summary Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    vehicleUtilizationData={vehicleUtilizationData}
                                    searchData={selectedSearchValues}
                                    total={total}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}

